export default "__VITE_ASSET__nBqnLND3__"